import React, { useState, useEffect } from "react";
import Navbar from "../Ui/Navbar";
import { Outlet } from "react-router-dom";
import Footer from "../Ui/Footer";

const FootNav = () => {
  const [cartItems, setCartItems] = useState(() => {
    try {
      const stored = localStorage.getItem("cartItems");
      return stored ? JSON.parse(stored) : [];
    } catch {
      return [];
    }
  });

  // Sync cart state across tabs and local updates
  useEffect(() => {
    const syncCart = () => {
      try {
        const stored = localStorage.getItem("cartItems");
        setCartItems(stored ? JSON.parse(stored) : []);
      } catch {
        setCartItems([]);
      }
    };

    window.addEventListener("storage", syncCart);
    window.addEventListener("cartUpdated", syncCart);
    return () => {
      window.removeEventListener("storage", syncCart);
      window.removeEventListener("cartUpdated", syncCart);
    };
  }, []);

  const handleAddToCart = (item) => {
    try {
      const stored = localStorage.getItem("cartItems");
      const current = stored ? JSON.parse(stored) : [];
      const updated = [...current, item];
      localStorage.setItem("cartItems", JSON.stringify(updated));
      setCartItems(updated);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (e) {
      console.error("Failed to add to cart", e);
    }
  };

  const handleUpdateCart = (newCartItems) => {
    try {
      localStorage.setItem("cartItems", JSON.stringify(newCartItems));
      setCartItems(newCartItems);
      window.dispatchEvent(new Event("cartUpdated"));
    } catch (e) {
      console.error("Failed to update cart", e);
    }
  };

  return (
    <div>
      <Navbar cartCount={cartItems.length} />
      <Outlet context={{ onAddToCart: handleAddToCart, onUpdateCart: handleUpdateCart, cartItems }} />
      <Footer />
    </div>
  );
};

export default FootNav;
